<template>
  <div class="flex flex-col min-h-0 min-w-0 w-full h-full">
    <div
      class="border-b border-mid-neutral-50 h-14 flex items-center justify-between px-6 bg-white z-10 shrink-0"
    >
      <div class="flex items-center gap-2 text-dark-neutral-500">
        <span class="material-symbols-outlined">microwave</span>
        <h2 class="font-semibold">Sterilization</h2>
      </div>
    </div>
    <Specifications :composable="composable" />
  </div>
</template>
<script setup lang="ts">
import { Specifications, useSpecifications } from "specifications";
import { lifecyclePhasesState } from "states/lifecyclePhases";
import { useSterilizationSpecificationsState } from "states/sterilization";
import { variantsState } from "states/variants";
import { useRouter } from "vue-router";

const variants = variantsState();
const { phases } = lifecyclePhasesState();
const router = useRouter();
const sterilizationSpecs = useSterilizationSpecificationsState();
const composable = useSpecifications({
  variants,
  phases,
  specificationsState: sterilizationSpecs,
  onSpecificationClick: (specification) => {
    router.push(
      `/compliance/microbiology/sterilization/specification/${specification.id}`
    );
  },
});
</script>
